/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_5_ProblemInputs */

const et_portfolio_project_5_problem = /** @type {(inputs: Portfolio_Project_5_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aeglane ja ebaturvaline veebileht, mis kahjustas SEO positsioone ja põhjustas kasutajate lahkumist.`)
};

const en_portfolio_project_5_problem = /** @type {(inputs: Portfolio_Project_5_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slow, insecure website hurting SEO rankings and causing users to drop off.`)
};

/**
* | output |
* | --- |
* | "Slow, insecure website hurting SEO rankings and causing users to drop off." |
*
* @param {Portfolio_Project_5_ProblemInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_5_problem = /** @type {((inputs?: Portfolio_Project_5_ProblemInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_5_ProblemInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_5_problem(inputs)
	return en_portfolio_project_5_problem(inputs)
});